import React from 'react';
import styled from 'styled-components';
import AudioRecorder from 'features/AudeoRecorderNew';
import AudioPicker from 'features/forms/AudioPicker';

const ImageContainer = styled.div`
    height: auto;
    flex: 1;
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    align-items: center;
    justify-content: center;
    position: relative;
`;

const Section = styled.div`
    width: 100%;
    margin-bottom: 16px;
`;

const OrDivider = styled.div`
    width: 100%;
    margin-bottom: 16px;
    text-align: center;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
`;

const UploadSection = styled.div`
    width: 100%;
    pointer-events: ${p => (p.$disabled ? 'none' : 'auto')};
    opacity: ${p => (p.$disabled ? 0.6 : 1)};
`;

const SectionLabel = styled.div`
    width: 100%;
    margin-bottom: 8px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: #495057;
`;

export default function MatchMakingAudio({
    source,
    handlePicture,
    onMediaUploaded,
    style = {},
    disabled = false,
    imageClassName = '',
    containerClassName = '',
    setButtonDisabled = () => {},
    sectionLabel = '',
    audioRole = 'match',
}) {
    const handleAudio = (url) => {
        handlePicture(url);
        if (url && onMediaUploaded) {
            onMediaUploaded(url);
        }
    };

    const recordMessage =
        audioRole === 'question'
            ? 'Record audio for the question'
            : 'Record audio for the match item';
    const uploadMessage =
        audioRole === 'question'
            ? 'Upload an audio file for the question'
            : 'Upload an audio file for the match item';

    return (
        <div className={imageClassName}>
            <ImageContainer className={containerClassName} style={style}>
                <Container>
                    {sectionLabel ? <SectionLabel>{sectionLabel}</SectionLabel> : null}
                    <Section>
                        <AudioRecorder
                            handleAudio={handleAudio}
                            index={0}
                            currentSubmission={{}}
                            refresh={() => {}}
                            source={source}
                            hasSaveButton
                            message={recordMessage}
                            setButtonDisabled={setButtonDisabled}
                            disabled={disabled}
                        />
                    </Section>
                    <OrDivider>OR</OrDivider>
                    <UploadSection $disabled={disabled}>
                        <AudioPicker
                            message={uploadMessage}
                            onChange={handleAudio}
                            setButtonDisabled={setButtonDisabled}
                        />
                    </UploadSection>
                </Container>
            </ImageContainer>
        </div>
    );
}
